import type { ProductCatalogVariant } from 'modules/it_management/lib/productCatalogGraphql'

export type DistributorProductVariant = ProductCatalogVariant

export type DistributorOffer = NonNullable<DistributorProductVariant['offers']>[number]

export type OfferType = 'renting' | 'credit' | 'onetime'

export type DeviceCatalogView = 'all' | 'saved' | 'offers' | 'zero-touch' | 'category'

export type AttributeFilters = Record<string, string[]>

export type FilterSection = {
  id: string
  label: string
  options: { value: string; label: string }[]
  selectedValues: string[]
  onChange: (values: string[]) => void
}

export type ProductGroup = {
  id: string
  title: string
  description?: string
  items: DistributorProductVariant[]
}

/**
 * Maps API typeName values to user-facing category IDs.
 * Key = category sidebar ID, Value = array of matching typeName values from API.
 */
export const CATEGORY_TYPE_MAP: Record<string, string[]> = {
  accessories: ['accessory', 'accessories'],
  audio_video: ['audio', 'video', 'audio & video', 'audio_video'],
  computers: ['laptop', 'desktop', 'computer', 'computers'],
  mobile_phones: ['phone', 'mobile', 'mobile phone', 'mobile_phone'],
  monitors: ['monitor', 'monitors', 'display'],
  networking_it: ['networking', 'network', 'router', 'switch', 'networking & it'],
  tablets: ['tablet', 'tablets'],
  wearables: ['wearable', 'wearables', 'watch', 'smartwatch'],
}

/**
 * Reverse lookup: given a typeName from the API, return the category ID.
 */
function getCategoryForTypeName(typeName: string | null | undefined): string | undefined {
  if (!typeName) return undefined
  const normalized = typeName.toLowerCase().trim()
  for (const [categoryId, typeNames] of Object.entries(CATEGORY_TYPE_MAP)) {
    if (typeNames.includes(normalized)) return categoryId
  }
  return undefined
}

export const SAVED_IDS_STORAGE_KEY = 'device_catalog_saved_ids'

// ---- Cart types ----

export type CartItemAddon = {
  id: string
  label: string
  pricePerMonth: number
}

export type CartItem = {
  variantId: string
  /** Product id for marketplace cell API (variant.product?.id or variantId fallback) */
  productId?: string
  name: string
  price: number
  image: string
  quantity: number
  addons: CartItemAddon[]
  offerId: string
  /** For display: 'onetime' | 'renting' | 'credit' */
  offerType: OfferType
  /** Period in months (null for onetime) */
  offerPeriod: number | null
}

export const CART_STORAGE_KEY = 'device_catalog_cart'
